import React from "react";
import { Link } from "react-router-dom";

/**
 * Just the big Create New Hunt button.
 */
export const CreateNewHuntButton = props => {
   const { buttonText, linkTo } = props;

   return (
      <div className="create-new-hunt">
         <Link to={linkTo} className="btn btn-default btn-lg primary-link top-margin">
            {buttonText}
         </Link>
      </div>
   )
};



// WEBPACK FOOTER //
// ./src/components/yourpage/CreateNewHuntButton.js